module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.blogs) ? _c('div', {
    staticClass: "custom-blog-list"
  }, [_c('div', {
    staticClass: "custom-blog-list__title"
  }, [_vm._v("Setting Things Straight")]), _c('h4', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "2rem"
    }
  }, [_vm._v("The Lucas Orthodontics Blog")]), _c('div', {
    staticClass: "custom-blog-list__container"
  }, _vm._l((_vm.blogs), function(blog, i) {
    return (i <= _vm.pages) ? _c('a', {
      key: i,
      staticClass: "custom-blog-list__item",
      on: {
        "click": function($event) {
          _vm.redirect(blog.slug)
        }
      }
    }, [_c('div', {
      staticClass: "custom-blog-list__item-photo",
      style: ({
        backgroundImage: 'url(' + blog.better_featured_image.source_url + ')'
      })
    }), _c('div', {
      staticClass: "custom-blog-list__item-title",
      domProps: {
        "innerHTML": _vm._s(blog.title.rendered)
      }
    }), _c('div', {
      staticClass: "custom-blog-list__item-date",
      domProps: {
        "innerHTML": _vm._s("<span>" + blog.date.slice(5, 7) + "</span>/<span>" + blog.date.slice(8, 10) + "</span>/<span>" + blog.date.slice(0, 4) + "</span>")
      }
    }), _c('a', {
      staticClass: "custom-blog-list__item-link",
      on: {
        "click": function($event) {
          _vm.redirect(blog.slug)
        }
      }
    }, [_vm._v("Learn More")])]) : _vm._e()
  })), _c('div', {
    staticClass: "custom-blog-list__loadmore"
  }, [(_vm.pages < _vm.blogs.length) ? _c('div', {
    staticClass: "custom-blog-list__loadmore-btn",
    on: {
      "click": function($event) {
        _vm.pages = _vm.pages + 5
      }
    }
  }, [_vm._v("Read More...")]) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bb5cb5a","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/custom/custom-blog-list/custom-blog-list.pug
// module id = 637
// module chunks = 1